module.exports = __webpack_public_path__ + "img/contact.0d8633e4.png";